import { render, staticRenderFns } from "./PreviewData.vue?vue&type=template&id=5934229a&scoped=true&"
import script from "./PreviewData.vue?vue&type=script&lang=js&"
export * from "./PreviewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934229a",
  null
  
)

export default component.exports